




























import { Component, Vue, Prop } from "vue-property-decorator";
import validation from "@/utils/validation";
@Component
export default class Home extends Vue {
  @Prop({ type: Boolean, default: false }) public showAccount;
  @Prop({ type: Boolean, default: false }) public showNickName;
  @Prop({ type: String, default: "" }) public account;
  @Prop({ type: String, default: "" }) public nickName;
  public rule = {
    account: [
      {
        required: true,
        trigger: "blur",
        validator: this.validateAccount,
        min: 6,
        max: 20,
      },
    ],
    nickName: [
      {
        required: true,
        trigger: "blur",
        validator: this.validateNickName,
      },
    ],
  };
  public formInline = {
    account: "",
    nickName: "",
  };
  public mounted() {
    this.formInline.account = this.account;
    this.formInline.nickName = this.nickName;
    this.$nextTick(() => {
      (this as any).$refs.taskNameInput.focus();
    });
  }
  public validateAccount(rule, value, callback) {
    if (value === "") {
      callback(new Error("请填写盒子号"));
    } else if (!validation.accountRules(value)) {
      callback(new Error("盒子必须由英文数字组合"));
    } else {
      this.$emit("accountChange", this.formInline.account);
      callback();
    }
  }
  public validateNickName(rule, value, callback) {
    if (value === "") {
      callback(new Error("请填写昵称"));
    } else if (validation.nickName(value) > 28) {
      callback(new Error("超出限定字数"));
    } else {
      this.$emit("nickNameChange", this.formInline.nickName);
      callback();
    }
  }
  public clearBlank() {
    this.formInline.nickName = this.formInline.nickName.replace(/[<>&]/g, "");
    this.formInline.nickName = this.$fn.filter(this.formInline.nickName);
  }
  public clearAccount() {
    this.formInline.account = this.$fn.filter(this.formInline.account);
  }
}
